import { useMutation, useQueryClient } from "@tanstack/react-query"
import { makeUpdateSynthesisSession } from "../../domain/use-cases/update-synthesis-session"
import { httpSynthesisSessionRepository } from "../../data/repositories/synthesis-session-repository"
import type { UpdateSynthesisSessionInput } from "../../domain/entities/synthesis-session"

const update = makeUpdateSynthesisSession(httpSynthesisSessionRepository)

export const useUpdateSynthesisSession = () => {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({
      id,
      input,
    }: {
      id: string
      input: UpdateSynthesisSessionInput
    }) => update(id, input),
    onSuccess: (session) => {
      void qc.setQueryData(["synthesis-sessions", session.id], session)
      void qc.invalidateQueries({
        queryKey: ["synthesis-sessions"],
        exact: true,
      })
    },
  })
}
